export default __webpack_public_path__ + "images/YK.db462fd.png";